<script lang="ts">
    export let label: string;
</script>

<div>
    {label}
</div>

<style>
    div {
        color: #565656;
        font-size: 0.8rem;
    }
</style>
